/* eslint-disable jira/filename-case */
import { merge } from 'icepick';
import { defaultOptions } from './fetch-default-options.tsx';
import FetchError from './errors.tsx';
import { getReroutableURL } from './get-reroutable-url.tsx';
import { applyObservabilityHeaders } from './observability-headers.tsx';
import { getTraceId } from './trace-id.tsx';

/**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */
// the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const fetchJson = <TResponse extends any = any>(
	url: string,
	options: RequestInit = {},
): Promise<TResponse> =>
	fetch(getReroutableURL(url), applyObservabilityHeaders(url, merge(defaultOptions, options))).then(
		(response) => {
			if (!response.ok) {
				const traceId = getTraceId(response);
				if (traceId !== undefined && traceId.length > 0) {
					throw new FetchError(
						response.status,
						`Fetch call failed with status code: ${response.status}`,
						traceId,
						response,
					);
				} else {
					throw new FetchError(response.status, undefined, undefined, response);
				}
			}

			// oxlint-disable-next-line typescript/consistent-type-assertions
			return response.json() as Promise<TResponse>;
		},
	);

export default fetchJson;
